const validNumber = (fieldValue: any): boolean => {
  // Will be handled by the required validator.
  if (fieldValue === undefined || fieldValue === null || !fieldValue.length) return true;

  return !isNaN(fieldValue);
};

export default validNumber;
